import { DateTime } from 'luxon';
import React, { useCallback } from 'react';
import { ButtonSizes, PrimaryButton, SecondaryButton } from 'src/shared/design-system/Buttons';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'src/shared/design-system/Modal';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useLocation } from 'src/shared/hooks/useLocation';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';

const StyledModal = styled(Modal)`
  padding: ${Spacing.SINGLE_HALF};
  max-height: 80vh;
`;

const FooterFlex = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ConsumerOrderUpdateDeliveryDateModal: React.FC<{
  isShowing: boolean;
  isCartEmpty: boolean;
  onClose: () => void;
  onClick: () => void;
  nextDeliveryDate: DateTime | null;
}> = ({ isShowing, isCartEmpty, onClose, onClick, nextDeliveryDate }) => {
  const history = useHistory();
  const location = useLocation();

  const label = isCartEmpty ? 'Update' : 'Clear Cart';

  const handleOnClick = useCallback(() => {
    onClick();
    history.replace(location.pathname + location.search);
    onClose();
  }, [onClose, onClick]);

  return (
    <StyledModal isShowing={isShowing} showCloseButton onClose={onClose}>
      <ModalHeader>Delivery Date Update</ModalHeader>
      <ModalBody>
        <p>
          The delivery date must be updated to add this item to the cart,{' '}
          {nextDeliveryDate && (
            <strong>
              {nextDeliveryDate.weekdayLong}, {nextDeliveryDate.monthLong} {nextDeliveryDate.day}
            </strong>
          )}
          {isCartEmpty ? '' : '. All of your items in your cart will be removed.'}
        </p>
      </ModalBody>
      <ModalFooter>
        <FooterFlex>
          <SecondaryButton size={ButtonSizes.S} onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton size={ButtonSizes.S} onClick={handleOnClick}>
            {label}
          </PrimaryButton>
        </FooterFlex>
      </ModalFooter>
    </StyledModal>
  );
};
